// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Mwrs6","search-input":"_30bbX","search-input-icon":"QY5hf","search-icon":"yHPRR","search":"_3wAOj","search-box":"_1KYhV"};